<template>
    <div>12345</div>
  </template>
  
  <script>
  export default {
    name: 'NewPage'
  }
  </script>
  